import React from 'react';
import { BodyText, Grid } from 'ui-toolkit';
import { PolicyTypesForm } from './PolicyTypesForm';
import { HoldOpenDisplay } from './HoldOpenDisplay';

export const PolicyTypesInfoContainer: React.FC = () => {
  return (
    <Grid columnCount={2}>
      <BodyText>Policy Types</BodyText>
      <Grid>
        <PolicyTypesForm />
        <HoldOpenDisplay />
      </Grid>
    </Grid>
  );
};
